<template>
  <v-simple-table>
    <template v-slot:default>
      <tbody>
        <tr v-for="(item, index) in desserts" :key="item.name">
          <th class="text-left pl-1 py-2" :class="index === 0 ? 'th_top' : ''">
            {{ item.name }}
          </th>
          <td class="text-left pl-1 py-2" :class="index === 0 ? 'td_top' : ''">
            <div v-html="item.value"></div>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import config from "../../config"

export default {
  computed: {
    // flags
    isMultipleCondition() {
      return this.$store.getters.sendApiParams.length > 1;
    },
    desserts() {
      let arry = []

      if (!this.$store.getters.selectedSubjectHasChild && !(this.$store.getters.selectedSubject && !this.$store.getters['sheet/isPresetMode'])) {
        arry.push({ name: '学年', value: this.$store.state.top.selectedGrade.name })
      }

      let subject_name = this.$store.state.top.selectedSubject.name
      let subjectOptionNames = []

      const params = this.$store.getters.sendApiParams.reduce((accumlator, param) => {
        const subject = this.$store.state.master.allSubjects.find(subject => subject.code == param.code)
        const shortName = subject.shortName

        // 分野が別れていたら分野名の略称を前につける
        const beforeText = this.isMultipleCondition ? shortName + '：' : ''

        // 分野名取得
        if (subject_name !== subject.name) subjectOptionNames.push(shortName)

        if (!config.publisherNoneSubjecs.includes(subject.code)) {
          accumlator['教科書'].push(beforeText + (param.selectedPublisher?.name || ''))
          accumlator['教科書範囲'].push(beforeText + param.publisherPages.map(page => { return 'p.' + page.start + '〜p.' + page.end }).join('、'))
        }
        if (config.subjects.TAIIKU_JITSUGI === subject.code) {
          accumlator['競技'].push(param.selectedAthleticEvents.map((athletic) => athletic.name).join('、'))
        }
        // 分野1つで検索したけど、問題入替で2分野になった時の対応
        const subjectCodes = this.isMultipleCondition ? [subject.code] : Object.keys(this.$store.getters['sheet/perSubjectQuestionCount'])
        subjectCodes.forEach(subjectCode => {
          const setsumonSubject = this.$store.state.master.allSubjects.find(subject => subject.code == subjectCode)
          const setsumonBeforeText = (subjectCodes.length > 1 || this.isMultipleCondition) ? setsumonSubject.shortName + '：' : ''
          var setsumon_cnt_text = `${this.$store.getters['sheet/perSubjectQuestionCount'][subjectCode] || 0}問`
          if (!this.$store.getters['sheet/isPresetMode'] && param.questionNum) {
            setsumon_cnt_text += `（${param.questionNum}問で指定）`
          }
          accumlator['設問数'].push(setsumonBeforeText + setsumon_cnt_text)
        })

        if (!this.$store.getters.selectedSubjectIsSkill) {
          // プリセットは難易度未定義のため - を表示
          if (this.$store.getters['sheet/isPresetMode']) {
            if (!accumlator['難易度'].length) accumlator['難易度'].push('-')
          } else {
            accumlator['難易度'].push(beforeText + param.selectedDifficulty.name)
          }
        }

        return accumlator
      }, { '教科書': [], '教科書範囲': [], '設問数': [], '難易度': [], '競技': [] })

      if (subjectOptionNames.length > 0) subject_name = subject_name + '（' + subjectOptionNames.join('・') + '）'
      arry.push({ name: '教科', value: subject_name })

      Object.entries(params).forEach(([name, values]) => {
        if (values.length > 0) {
          arry.push({ name: name, value: values.join('<br>') })
        }
      })

      const usedItems = this.$store.state.sheet.usedItems
      const materialNames = [...new Set(usedItems.map(x => x.material.split(', ')).flat())]
      arry.push({ name: '使用問題', value: materialNames.join(', ') })
      arry.push({ name: '問題用紙', value: this.$store.state.sheet.questionImages.length })
      arry.push({ name: '解答用紙', value: this.$store.state.sheet.answerImages.length })

      return arry
    },
  },
}
</script>

<style lang="stylus" scoped>
  th
    background-color: #efefef;
    font-size 14px !important
  .th_top
    min-width 200px
    border-top #3872b0 4px solid
  .td_top
    border-top #b3b3b3 4px solid
</style>
